import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        screenWidth: document.documentElement.clientWidth, //屏幕宽度
        screenHeight: document.documentElement.clientHeight, //屏幕高度
        selNavInd: 0,//导航选中项

        showMakeAppoint:false,//预约演示弹窗
        showVideo:false,//视频播放弹窗
    },
    mutations: {
        change(state, payload) {
            state.screenWidth = payload.width
            state.screenHeight = payload.height
        },
        changeNav(state, payload) {
            state.selNavInd = payload
        },
        changeShowMakeAppoint(state, payload) {
            state.showMakeAppoint = payload
        },
        changeShowVideo(state, payload) {
            state.showVideo = payload
        },
    }
})



export default store;



// WEBPACK FOOTER //
// ./src/store/index.js